import { createContext } from 'react'

const BamContext = createContext()

export default BamContext
